type StateType = {
    length: number;
    list: any[];
};

export const state: StateType = {
    length: 0,
    list: [],
};
